module.exports = __webpack_public_path__ + "static/img/ESI2.d4e7fcb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ESI2.png
// module id = j6l6
// module chunks = 1